import React from 'react';
import originalImg from './research_facilities.jpg'
import { useMobileBreakpoint } from '../breakpoints';
import { Heading, HeadingContent, HeadingImage, FacilitiesSection, Facility, FacilityTitle, FacilityLink, DescriptionText, FacilityDescriptionText, HeadingText, FacilityRow, Wrapper } from './index.styled';
import { MobileHeading } from './components/MobileHeading';
import Fade from 'react-reveal/Fade';
import { useTranslation } from 'react-i18next';

export const ResearchFacilities = () => {
  const { t } = useTranslation();
  const facilities = t(`AboutUsPage.ResearchFacilities.facilities`, { returnObjects: true });
  const firstRow = facilities.slice(0, 3);
  const lastRow = facilities.slice(3, 6);
  const rows = [firstRow, lastRow];
  const isMobile = useMobileBreakpoint();
  const isIE = /*@cc_on!@*/false || !!document.documentMode;

  return (
    <Fade up>
    <Wrapper id='global-facilities'>
      {
        isMobile ? (
          <MobileHeading image={originalImg} title={t(`AboutUsPage.ResearchFacilities.heading.title`)} />
        ) :
          (
            <Heading>
                <HeadingImage>
                  <img src={originalImg} alt='' role='presentation' />
                </HeadingImage>
                <HeadingContent>
                  <HeadingText>{t(`AboutUsPage.ResearchFacilities.heading.title`)}</HeadingText>
                  <DescriptionText>{t(`AboutUsPage.ResearchFacilities.heading.description`)}</DescriptionText>
                </HeadingContent>
            </Heading>
          )
      }
        <FacilitiesSection>
          {
            rows.map((row, rowIndex) => {
              return (
                <FacilityRow key={row[0].title}>
                  {
                    row.map((facility, index) => {
                      return (
                        <Facility ie={isIE.toString()} key={facility.title}>
                          <FacilityTitle>{facility.title}</FacilityTitle>
                          <FacilityDescriptionText ie={isIE.toString()}>{facility.description}</FacilityDescriptionText>
                          <FacilityLink href={facility.url} target={`_blank`}>{facility.cta}</FacilityLink>
                        </Facility>
                      )
                    }
                    )
                  }
                </FacilityRow>
              )
            })
          }
        </FacilitiesSection>
    </Wrapper>
    </Fade>
  )
}